import React from "react";

import styled from "styled-components";

const Message = styled.div`
  display: block;
  width: 100%;
  color: #e66c1f;
  text-align: right;
  margin-top: 5px;
`;

const validationMessage = (props) => {
  return <Message>{props.message}</Message>;
};

export default validationMessage;
